import * as React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import { useSelector } from 'react-redux'
import { isLoaded, isEmpty } from 'react-redux-firebase'

import Login from './containers/Login';
import Signup from './containers/Signup';
import ContentSubmission from './containers/ContentSubmission';
import Dashboard from './containers/Dashboard';
import PodcastDetails from './containers/PodcastDetails';
import PodcastEdit from './containers/PodcastEdit';
import PodcastCreate from './containers/PodcastCreate';
import Users from './containers/Users';
import UserCreate from './containers/UserCreate';
import UserEdit from './containers/UserEdit';
import ForgotPassword from './containers/ForgotPassword';
import ResetPassword from './containers/ResetPassword';
import UserActivation from './containers/UserActivation';
import Account from './containers/Account';

import "./scss/style.scss"

const PrivateRoute = ({ children, ...rest }) => {
  const auth = useSelector((state) => state.firebase.auth);

  if (!isLoaded(auth)) {
    return <React.Fragment />;
  }

  if (isLoaded(auth) && !isEmpty(auth)) {
    return <Route {...rest}>{children}</Route>;
  }

  return (
    <Route {...rest}>
      <Redirect to="/login" />
    </Route>
  );
};

const AdminRoute = ({ children, ...rest }) => {
  const auth = useSelector((state) => state.firebase.auth);
  const profile = useSelector(state => state.firebase.profile)

  if (!isLoaded(auth) || !isLoaded(profile)) {
    return <React.Fragment />;
  }

  if (isEmpty(auth)) {
    return (
      <Route {...rest}>
        <Redirect to="/login" />
      </Route>
    );
  }

  if (!profile.isAdmin) {
    return (
      <Route {...rest}>
        <Redirect to="/" />
      </Route>
    );
  }


  return <Route {...rest}>{children}</Route>;
}

const App = () => {
  return (
    <Router>
      <Switch>
        <Route path="/forgot-password">
          <main role="main">
            <ForgotPassword />
          </main>
        </Route>
        <Route path="/reset-password">
          <main role="main">
            <ResetPassword />
          </main>
        </Route>
        <Route path="/login">
          <main role="main">
            <Login />
          </main>
        </Route>
        <Route path="/signup">
          <main role="main">
            <Signup />
          </main>
        </Route>
        <Route path="/submit">
          <ContentSubmission />
        </Route>
        <Route path="/activate/:userId">
          <UserActivation />
        </Route>
        <PrivateRoute path="/account">
          <Account />
        </PrivateRoute>
        <AdminRoute path="/users/create">
          <UserCreate />
        </AdminRoute>
        <AdminRoute path="/users/:userId/edit">
          <UserEdit />
        </AdminRoute>
        <AdminRoute path="/users">
          <Users />
        </AdminRoute>
        <PrivateRoute path="/podcasts/by-status/:status">
          <Dashboard />
        </PrivateRoute>
        <AdminRoute path="/podcasts/by-user/:userId/create">
          <PodcastCreate />
        </AdminRoute>
        <AdminRoute path="/podcasts/by-user/:userId">
          <Dashboard />
        </AdminRoute>
        <AdminRoute path="/podcasts/details/:podcastId/edit">
          <PodcastEdit />
        </AdminRoute>
        <PrivateRoute path="/podcasts/details/:podcastId">
          <PodcastDetails />
        </PrivateRoute>
        <PrivateRoute path="/podcasts/">
          <Dashboard />
        </PrivateRoute>
        <PrivateRoute path="/">
          <Redirect to="/podcasts/" />
        </PrivateRoute>
      </Switch>
    </Router>
  );
}

export default App;
